import type { WalletTypeEnum } from '@ps/isp-web-services-types';
import { camelCase } from 'lodash';

export const getWalletFieldName = (walletType: WalletTypeEnum, redeemable?: boolean) => {
  if (walletType === 'BONUS_CASH') {
    return redeemable ? 'bonusCash' : 'freeBet';
  }

  return camelCase(walletType);
};
